<template>
    <div class="search-panel__filter-slider">
        <div class="search-panel__slider-inputs">
            <div class="search-panel__slider-input-wrap">

                <div class="search-panel__slider-input-prefix">
                    {{ translations.from }}
                </div>

                <input
                    v-model="valueMin"
                    ref="inputMin"
                    @focusout="focusOutMin"
                    @keypress="isNumber"
                    class="search-panel__slider-input"
                />

                <span class="range-slider__value">
                    {{ formatVisibleValue(valueMin) }}
                </span>

            </div>

            <div class="search-panel__slider-inputs-separator">—</div>

            <div class="search-panel__slider-input-wrap">

                <div class="search-panel__slider-input-prefix">
                    {{ translations.to }}
                </div>

                <input
                    v-model="valueMax"
                    ref="inputMax"
                    @focusout="focusOutMax"
                    @keypress="isNumber"
                    class="search-panel__slider-input"
                />

                <span class="range-slider__value">
                    {{ formatVisibleValue(valueMax, 'to') }} {{slider.label}}
                </span>

            </div>
        </div>

        <VueSlider
            ref="slider"
            v-model="sliderValue.value"
            :silent="true"
            :dotSize="0"
            :height="1"
            :contained="true"
            :tooltip="'none'"
            :min="slider.min"
            :max="slider.max"
            :interval="slider.interval"
            @drag-start="dragStart"
            @drag-end="dragEnd"
            @change="dragEnd"
        />

        <input v-if="isChangeDone" type="hidden" :name="slider.category + '[min]'" :value="slider.value[0]">
        <input v-if="isChangeDone" type="hidden" :name="slider.category + '[max]'" :value="slider.value[1]">
    </div>
</template>

<script>
import InputMask from 'inputmask';
import VueSlider from 'vue-slider-component';
import {convertToDigit, roundToMillions, roundToThousands} from "../../../../parametric/src/assets/utils";

export default {
    props: ['changed', 'slider', 'translations'],

    components: {
        VueSlider
    },

    data() {
        return {
            valueMin    : 0,
            valueMax    : 0,
            oldVal      : null,
            focusedInput: false,
            sliderValue : this.slider,
            isChangeDone: false
        };
    },

    watch: {
        slider() {
            this.sliderValue = this.slider;
        },

        sliderValue: {
            handler(val) {
                this.valueMin = this.toNumber(val.value[0]);
                this.valueMax = this.toNumber(val.value[1]);
            },
            deep: true
        },

        valueMin(val) {
            if (!this.toNumber(val)) {
                this.valueMin = 0;
            }
        },

        valueMax(val) {
            if (!this.toNumber(val)) {
                this.valueMax = 0;
            }
        }
    },

    mounted() {
        const optionsMask = {
            placeholder   : ' ',
            rightAlign    : false,
            radixPoint    : ',',
            autoGroup     : true,
            groupSeparator: ' ',
            groupSize     : 3,
            autoUnmask    : true
        };

        new InputMask('decimal', optionsMask).mask(this.$refs.inputMin);
        new InputMask('decimal', optionsMask).mask(this.$refs.inputMax);

        this.valueMin = this.slider.value[0];
        this.valueMax = this.slider.value[1];
    },

    methods: {
        formatVisibleValue(value, valuePrefix = 'from') {
            if (this.slider.category === 'area') {
                return convertToDigit(value);
            }

            const suffix = valuePrefix === 'to' ? ' МЛН' : '';

            return `${roundToMillions(value)}${suffix}`;
        },

        // Запрет на ввод нечисловых значений (символы k/m выводят нули в маске, п)
        isNumber(event) {
            const evt = event ? event : window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;

            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();

                return false;
            }

            return true;
        },

        focusOutMin() {
            const inputValue = this.toNumber(this.valueMin);

            if (inputValue < this.slider.min) {
                this.slider.value[0] = this.slider.min;
                this.valueMin = this.slider.min;
            } else if (inputValue >= this.slider.value[1]) {
                this.slider.value[0] = this.slider.value[1];
                this.valueMin = this.slider.value[1];

                if (inputValue > this.slider.max) {
                    this.slider.value[1] = this.slider.max;
                    this.valueMax = this.slider.max;
                } else {
                    this.slider.value[1] = inputValue;
                    this.valueMax = inputValue;
                }
            } else {
                this.slider.value[0] = inputValue;
                this.valueMin = inputValue;
            }

            this.$refs.slider.setValue(this.slider.value);

            this.$nextTick(() => {
                this.dragEnd();
            });
        },

        focusOutMax() {
            const inputValue = this.toNumber(this.valueMax);

            if (inputValue > this.slider.max) {
                this.slider.value[0] = this.slider.min;
                this.valueMin = this.slider.min;
            } else if (inputValue < this.slider.value[0]) {
                this.slider.value[1] = this.slider.value[0];
                this.valueMax = this.slider.value[0];

                if (inputValue < this.slider.min) {
                    this.slider.value[0] = this.slider.min;
                    this.valueMin = this.slider.min;
                } else {
                    this.slider.value[0] = inputValue;
                    this.valueMin = inputValue;
                }
            } else {
                this.slider.value[1] = inputValue;
                this.valueMax = inputValue;
            }

            this.$refs.slider.setValue(this.slider.value);

            this.$nextTick(() => {
                this.dragEnd();
            });
        },

        dragStart() {
            this.oldVal = this.slider.value;
        },

        dragEnd() {
            if (this.oldVal === this.slider.value) {
                return;
            }

            this.isChangeDone = true;

            this.$nextTick(() => {
                this.$emit('change');
                this.oldVal = this.slider.value;
            });
        },

        updateChange() {
            if (!this.changed.min && (this.slider.value[0] !== this.toNumber(this.oldVal[0]))) {
                this.changed.min = true;
            }

            if (!this.changed.max && (this.slider.value[1] !== this.toNumber(this.oldVal[1]))) {
                this.changed.max = true;
            }
        },

        toNumber(string) {
            return Number(string.toString().replace(/\s/g, ''));
        }
    }
};
</script>
